import { atom } from 'jotai';

const isVacanciesModalOpen = atom(false);

export default isVacanciesModalOpen;
